export default "__VITE_ASSET__Cr1SdAcW__"